import { appConfig } from './config.constants';

export const apiRoutesParent = {
    ROUTE_LOGIN                 : appConfig.API_ENDPOINT + '/loginPadre',
    ROUTE_EXISTEMAIL            : appConfig.API_ENDPOINT + '/registroPadre/existenciaEmail',
    ROUTE_REGISTER              : appConfig.API_ENDPOINT + '/registroPadre',
    ROUTE_VALIDATE_USER         : appConfig.API_ENDPOINT + '/registroPadre/validarUsuarioPadre',
    ROUTE_FORGOTPASSWORD        : appConfig.API_ENDPOINT + '/cuentaPadre/olvidoContrasena',
    ROUTE_VERIFYTOKEN_FP        : appConfig.API_ENDPOINT + '/cuentaPadre/aceptaRestablecerContrasena',
    ROUTE_UPDATE_PASSWORD       : appConfig.API_ENDPOINT + '/cuentaPadre/actualizarContrasena',
    ROUTE_PROFILE_STUDENT       : appConfig.API_ENDPOINT + '/moduloPadre/perfilEstudiante',
    ROUTE_BALANCE               : appConfig.API_ENDPOINT + '/moduloPadre/saldos',
    ROUTE_NOTES               : appConfig.API_ENDPOINT + '/moduloPadre/notas',
    ROUTE_MOVEMENT_HISTORY      : appConfig.API_ENDPOINT + '/moduloPadre/historialMovimientosEstudiante',
    ROUTE_AVISO                 : appConfig.API_ENDPOINT + '/avisoPadre',
    ROUTE_HORARIO_CALENDARIO    : appConfig.API_ENDPOINT + '/moduloPadre/horario',
    ROUTE_CERTIFICADO_NOTAS_PDF : appConfig.API_ENDPOINT + '/moduloPadre/notas/generarPdf',
    ROUTE_NOTAS_DETALLE           : appConfig.API_ENDPOINT + '/moduloPadre/notas/detalle',
    ROUTE_CERTIFICADO_NOTAS_ACADEMICAS_PDF : appConfig.API_ENDPOINT + '/moduloPadre/carrerasAcademicas/certificado',
    ROUTE_CERTIFICADO_MATERIA_ACADEMICA_PDF: appConfig.API_ENDPOINT + '/moduloPadre/materia/certificate',
    ROUTE_REPORTE_DTE           : appConfig.API_ENDPOINT + '/moduloPadre/dtes'
}

export const apiRoutesStudent = {
    ROUTE_LOGIN                 : appConfig.API_ENDPOINT + '/loginEstudiante',
    ROUTE_STUDENT_PASSWORD_UPDATE          : appConfig.API_ENDPOINT + '/moduloEstudiante/password/update',
    ROUTE_PROFILE_STUDENT       : appConfig.API_ENDPOINT + '/moduloEstudiante/perfilEstudiante',
    ROUTE_BALANCE               : appConfig.API_ENDPOINT + '/moduloEstudiante/saldos',
    ROUTE_NOTES                 : appConfig.API_ENDPOINT + '/moduloEstudiante/notas',
    ROUTE_MOVEMENT_HISTORY      : appConfig.API_ENDPOINT + '/moduloEstudiante/historialMovimientosEstudiante',
    ROUTE_AVISO                 : appConfig.API_ENDPOINT + '/moduloEstudiante/aviso',
    ROUTE_HORARIO_CALENDARIO    : appConfig.API_ENDPOINT + '/moduloEstudiante/horario',
    ROUTE_CERTIFICADO_NOTAS_PDF : appConfig.API_ENDPOINT + '/moduloEstudiante/notas/generarPdf',
    ROUTE_REPORTE_DTE           : appConfig.API_ENDPOINT + '/moduloEstudiante/dtes',
    ROUTE_DOMAIN_DATA           : appConfig.API_ENDPOINT + '/loginEstudiante/dataDominio',
    ROUTE_NOTAS_DETALLE           : appConfig.API_ENDPOINT + '/moduloEstudiante/notas/detalle',
    ROUTE_CERTIFICADO_NOTAS_ACADEMICAS_PDF : appConfig.API_ENDPOINT + '/moduloEstudiante/carrerasAcademicas/certificado',
    ROUTE_CERTIFICADO_MATERIA_ACADEMICA_PDF: appConfig.API_ENDPOINT + '/moduloEstudiante/materia/certificate'
}